module.exports = __webpack_public_path__ + "media/images/default_banner_1-0d86978267de4a1bbb05f168a9cad7a4.webp";